import { SongQuality } from '../responses/responseTypes';

export const DEFAULT_SONG_QUALITY: SongQuality = 'medium';
